import React from "react";
import EmailBlastViewPresenter from "./EmailBlastViewPresenter";
import {getObjectUseCase, upsertUseCase} from '../../../usecases/object';
import withRouter from "../../../withRouter";
import BaseFormPage from "../../../base/BaseFormPage";
import NavBar from "../../../components/navbar";

class EmailBlastViewPage extends BaseFormPage {
    constructor(props) {
        super(props);
        this.state = {object: {}, advanced: false};
        this.presenter = new EmailBlastViewPresenter(this, getObjectUseCase(), upsertUseCase());
    }

    getCollectionName() {
        return "emailBlast"
    }

    onClickAdvance() {
        this.setState({advanced: !this.state.advanced});
    }

    render() {
        const object = this.state.object;
        const schema = this.getSchema(this.getCollectionName());
        const formattedDate = object?.date
            ? new Date(object.date).toLocaleDateString(undefined, {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
            })
        : 'N/A'
        if (!schema) return <h1>no schema</h1>;
        return (
            <>
                <NavBar
                    action={() => (
                        <div className="dropdown dropstart d-inline-block">
                            <i role="button" data-bs-toggle="dropdown" className="bi bi-three-dots-vertical"></i>
                            <div className="dropdown-menu fs-xs">
                                <button
                                    onClick={this.onClickAdvance.bind(this)}
                                    className="dropdown-item py-3">
                                    <i className='bi bi-gear pe-2'/>Toggle Advance
                                </button>
                            </div>
                        </div>
                    )}/>
                <div className="overflow-auto">
                    <div className="h-100">
                        <div className="p-3 p-lg-4">
                            <div className="d-flex align-items-start mt-3">
                            <i className="bi bi-chevron-left" style={{ fontSize: '1.5rem' }} onClick={this.onClickBack.bind(this)}></i>
                            <h1 className="fw-bold text-capitalize"> {(schema.label || "Email Blast")} Details</h1>
                            </div>
                            <div className="mt-3 bg-white border border-gray rounded p-3 px-lg-5 py-lg-4">
                                <h6 className="text-muted fw-bolder">Title</h6>
                                <hr className='border border-gray border-1 opacity-100'/>
                                <div>{object.title}</div>
                            </div>
                            <div className="mt-3 bg-white border border-gray rounded p-3 px-lg-5 py-lg-4">
                                <h6 className="text-muted fw-bolder">Subject</h6>
                                <hr className='border border-gray border-1 opacity-100'/>
                                <div>{object.subject}</div>
                            </div>
                            <div className="mt-3 bg-white border border-gray rounded p-3 px-lg-5 py-lg-4">
                                <h6 className="text-muted fw-bolder">Date Submitted</h6>
                                <hr className='border border-gray border-1 opacity-100'/>
                                <div>{formattedDate}</div>
                            </div>
                            <div className="mt-3 bg-white border border-gray rounded p-3 px-lg-5 py-lg-4">
                            <h6 className="text-muted fw-bolder">Recipients</h6>
                            <hr className='border border-gray border-1 opacity-100'/>
                            <div>
                                {Array.isArray(object.client) && object.client.length > 0 ? (
                                object.client.map((client, index) => (
                                    <div key={index}>
                                    {client.first_name} {client.last_name}
                                    </div>
                                ))
                                ) : (
                                <div>No recipients selected</div>
                                )}
                            </div>
                            </div>
                            <div className="mt-3 bg-white border border-gray rounded p-3 px-lg-5 py-lg-4">
                                <h6 className="text-muted fw-bolder">Body</h6>
                                <hr className='border border-gray border-1 opacity-100'/>
                                <div>{object.body}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default withRouter(EmailBlastViewPage);
